import { useState, Fragment, useEffect } from "react";
import {Transition,  Listbox } from '@headlessui/react';
import { InputSearch, Heading, Paragraph,ButtonWithBg } from "../../../components/Kits";
import BlockView from "./BlockView";
import Table from "./Table";
import { Link } from "react-router-dom";
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import { useSelector, useDispatch } from "react-redux";
import { useToaster } from "../../../contexts/toaster";
import http from "../../../http-common";
import { objectToQueryString } from "../../../utils/table-manager";
import {
    formActions,
    databaseSourceActions
  } from "../../../redux/actions";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/Modals";
import { AiOutlineClose } from 'react-icons/ai'

export default function FormsList(){
    const { t } = useTranslation(["common", "project", "form"]);
    const data = [
        { name: 'All', id : 'all' },
        { name: 'Private', id: 'private' },
        { name: 'Public', id: 'public' },
    ]
    const dispatch = useDispatch()
    const toaster = useToaster()
    const [selected, setSelected] = useState(data[0])
    const [blockView, setBlockView] = useState(true)
    const forms = useSelector((state) => state.forms);
    // const [forms, setForms] = useState(useSelector((state) => state.forms));
    const [currentPageForms, setCurrentPageForms] = useState(1);
    const [paginationForms, setPaginationForms] = useState({
        pageSize: 10,
        total : 0,
      });
    const [loadingForms, setLoadingForms] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    let [isOpen, setIsOpen] = useState(false)
    const toggleModal = ()=>{
        setIsOpen(!isOpen)
    }

    const [getId, setGetId] = useState(null)

    function nextPage() {
        // Vérifier dab si on peut faire suivant
        
        if(currentPageForms < paginationForms.total){
            console.log('next')
            setCurrentPageForms(currentPageForms + 1)
        }
    }

    function prevPage() {
        // Vérifier dab si on peut faire suivant
        if(currentPageForms > 1){
            setCurrentPageForms(currentPageForms - 1)
        }
    }



    // useEffect(() => {
    //     dispatch(databaseSourceActions.databases());
    // })

    // const refreshForms = async () => {
    //     try {
    //       const qs = objectToQueryString({
    //           page : currentPageForms,
    //           limit : paginationForms.pageSize,
    //       });
    
    //       if(loadingForms === false){
    //         setLoadingForms(true)
    //         await http.get(`/forms${qs}`).then(function(response){
    //           console.log("response foooo", response)
    //           if(response.status === 200){
    //             // const dataRes = response
    //             setForms(response.data.data);
    //             setPaginationForms(prev => { return {...prev, total : response.data.totalPage}})
    //             setLoadingForms(false)
    //           }
    //         })
    //       }                                 
    //     } catch (err) {
    //         console.log(err)
    //     }
    // };

    // const refreshedForms = () => {
    //     refreshForms();
    // }

    // useEffect(() => {
    //     refreshedForms();
    // }, [currentPageForms])

    const handleDeleteForm = async () => {
        await dispatch(formActions.deleteForms(getId, toaster, setIsLoading, toggleModal));
    }

    console.log('forms', forms)

    return(
        <div>
            <div className="flex items-center justify-between mb-[50px]">
                <div className="max-w-[40%]">
                    <Heading title={t("form:formslist")} mb={"10px"} />
                </div>
            </div>
            <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                    <div className="w-[300px]">
                        <InputSearch 
                            placeholder="Search projects, forms..."
                        />
                    </div>
                    <div 
                        className={`h-[50px] w-[50px] rounded-[6px] cursor-pointer flex items-center justify-center transition-all ease-out duration-150 ${blockView ? "bg-white" : "bg-secondary-green-500"}`}
                        onClick={() => setBlockView(!blockView)}
                    >
                        {
                            blockView ? 
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.213 0C17.6747 0 20 2.16273 20 5.38122V14.6188C20 17.8654 17.7462 19.9769 14.2582 19.997L5.78805 20C2.32645 20 0 17.8373 0 14.6188V5.38122C0 2.1336 2.25379 0.023104 5.74181 0.00401808L14.2119 0H14.213ZM14.213 1.50678L5.74732 1.5108C3.18415 1.52486 1.65153 2.97137 1.65153 5.38122V14.6188C1.65153 17.0447 3.19846 18.4932 5.78695 18.4932L14.2527 18.4902C16.8159 18.4761 18.3485 17.0276 18.3485 14.6188V5.38122C18.3485 2.9553 16.8026 1.50678 14.213 1.50678ZM14.0007 13.5346C14.4565 13.5346 14.8264 13.8721 14.8264 14.288C14.8264 14.7039 14.4565 15.0414 14.0007 15.0414H6.05131C5.59549 15.0414 5.22554 14.7039 5.22554 14.288C5.22554 13.8721 5.59549 13.5346 6.05131 13.5346H14.0007ZM14.0007 9.32918C14.4565 9.32918 14.8264 9.6667 14.8264 10.0826C14.8264 10.4984 14.4565 10.836 14.0007 10.836H6.05131C5.59549 10.836 5.22554 10.4984 5.22554 10.0826C5.22554 9.6667 5.59549 9.32918 6.05131 9.32918H14.0007ZM9.08428 5.1335C9.54011 5.1335 9.91005 5.47102 9.91005 5.88689C9.91005 6.30276 9.54011 6.64028 9.08428 6.64028H6.05098C5.59516 6.64028 5.22521 6.30276 5.22521 5.88689C5.22521 5.47102 5.59516 5.1335 6.05098 5.1335H9.08428Z" fill="#6BCB77"/>
                            </svg>
                            :
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.35897 11.2821C8.53231 11.2821 8.71795 12.6974 8.71795 15.641C8.71795 17.1159 8.71795 18.1651 8.09846 18.9333C7.38564 19.8185 6.08821 20 4.35897 20C2.62974 20 1.33231 19.8185 0.619487 18.9333C0 18.1651 0 17.1169 0 15.6667L0.769231 15.641H0C0 12.6974 0.185641 11.2821 4.35897 11.2821ZM15.641 11.2821C19.8144 11.2821 20 12.6974 20 15.641C20 17.1159 20 18.1651 19.3805 18.9333C18.6677 19.8185 17.3703 20 15.641 20C13.9118 20 12.6144 19.8185 11.9015 18.9333C11.2821 18.1651 11.2821 17.1169 11.2821 15.6667L12.0513 15.641H11.2821C11.2821 12.6974 11.4677 11.2821 15.641 11.2821ZM4.57042 12.821L4.35897 12.8205C1.6831 12.8205 1.54588 13.0125 1.53884 15.2585L1.53927 16.1335C1.54413 17.0268 1.57817 17.6721 1.81641 17.9692C2.08821 18.3056 2.89538 18.4615 4.35897 18.4615C5.82256 18.4615 6.62974 18.3046 6.90154 17.9682C7.17949 17.6226 7.17949 16.8021 7.17949 15.6656C7.17949 13.1013 7.17949 12.833 4.57042 12.821ZM15.8525 12.821L15.641 12.8205C12.9652 12.8205 12.8279 13.0125 12.8209 15.2585L12.8213 16.1335C12.8262 17.0268 12.8602 17.6721 13.0985 17.9692C13.3703 18.3056 14.1774 18.4615 15.641 18.4615C17.1046 18.4615 17.9118 18.3046 18.1836 17.9682C18.4615 17.6226 18.4615 16.8021 18.4615 15.6656C18.4615 13.1013 18.4615 12.833 15.8525 12.821ZM4.35897 0C8.53231 0 8.71795 1.41538 8.71795 4.35897C8.71795 5.83385 8.71795 6.88308 8.09846 7.65128C7.38564 8.53641 6.08821 8.71795 4.35897 8.71795C2.62974 8.71795 1.33231 8.53641 0.619487 7.65128C0 6.88308 0 5.83487 0 4.38462L0.769231 4.35897H0C0 1.41538 0.185641 0 4.35897 0ZM15.641 0C19.8144 0 20 1.41538 20 4.35897C20 5.83385 20 6.88308 19.3805 7.65128C18.6677 8.53641 17.3703 8.71795 15.641 8.71795C13.9118 8.71795 12.6144 8.53641 11.9015 7.65128C11.2821 6.88308 11.2821 5.83487 11.2821 4.38462L12.0513 4.35897H11.2821C11.2821 1.41538 11.4677 0 15.641 0ZM4.57042 1.53892L4.35897 1.53846C1.6831 1.53846 1.54588 1.73048 1.53884 3.97646L1.53927 4.85147C1.54413 5.74476 1.57817 6.39004 1.81641 6.68718C2.08821 7.02359 2.89538 7.17949 4.35897 7.17949C5.82256 7.17949 6.62974 7.02256 6.90154 6.68615C7.17949 6.34051 7.17949 5.52 7.17949 4.38359C7.17949 1.81928 7.17949 1.55099 4.57042 1.53892ZM15.8525 1.53892L15.641 1.53846C12.9652 1.53846 12.8279 1.73048 12.8209 3.97646L12.8213 4.85147C12.8262 5.74476 12.8602 6.39004 13.0985 6.68718C13.3703 7.02359 14.1774 7.17949 15.641 7.17949C17.1046 7.17949 17.9118 7.02256 18.1836 6.68615C18.4615 6.34051 18.4615 5.52 18.4615 4.38359C18.4615 1.81928 18.4615 1.55099 15.8525 1.53892Z" fill="white"/>
                            </svg>
                        }
                    </div>
                </div>
                <Link to={'/adm/forms/create-form'}>
                    <ButtonWithBg 
                        title={t("common:createform")}
                        type='button'
                        bg={'primary'}
                        isSmall={true}
                    />
                </Link>
            </div>
            <div className="mt-[30px]">
                {
                    blockView ? 
                    <BlockView 
                        forms={forms} 
                        // handleDeleteForm={handleDeleteForm}
                        setGetId={setGetId} 
                        toggleModal={toggleModal}
                        t={t} 
                        loadingForms={loadingForms} 
                        length={paginationForms.pageSize} 
                    />
                    :
                    <Table forms={forms} t={t} loadingForms={loadingForms} length={paginationForms.pageSize} />
                }
            </div>
            {
                paginationForms.total > 1 &&
                <div className="flex items-center justify-between mt-[20px]">
                    <span className='text-[13px] font-[500] text-primary-blue-500'>{`Page ${currentPageForms} sur ${paginationForms.total}`}</span>
                    <div className="flex items-center justify-end gap-3">
                        <div 
                            onClick={prevPage}
                            className={`bg-primary-blue-500 bg-opacity-10 h-[40px] w-[40px] rounded-[6px] flex items-center justify-center cursor-pointer ${currentPageForms < 2 ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        >
                            <BsChevronLeft className="text-[16px] text-primary-blue-500" />
                        </div>
                        <div 
                            onClick={nextPage} 
                            className={`bg-primary-blue-500 bg-opacity-10 h-[40px] w-[40px] rounded-[6px] flex items-center justify-center cursor-pointer ${currentPageForms == paginationForms.total ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                        >
                            <BsChevronRight className="text-[16px] text-primary-blue-500" />
                        </div>
                    </div>
                </div>
            }

            {/* Delete */}
            <Modal show={isOpen} toggleModal={toggleModal} resetOverflow>
                <div className="border-b flex items-center justify-between gap-4 px-6 py-4">
                    <h4>
                        {"Delete form"}
                    </h4>
                    <div 
                        onClick={()=>{
                            toggleModal() 
                            setGetId(null)
                        }}
                        className="h-[30px] w-[30px] rounded-full bg-red-300 flex items-center justify-center cursor-pointer">
                        <AiOutlineClose className="text-[20px] font-bold text-red-500" />
                    </div>
                </div>
                <div className="max-h-[400px] overflow-x-hidden">
                    <div className="p-6">
                        <h4 className='text-[16px] font-bold mb-4'>
                            {`Attention this action is irreversible`}
                        </h4>
                        <p className='text-[14px] text-black text-opacity-70'>
                            {`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s`}
                        </p>
                    </div>
                    <div className='flex justify-end mb-[10px] px-6 pt-3 border-t'>
                        <ButtonWithBg 
                            title={isLoading ? 'Deleting...' : 'Delete'}
                            disabled={isLoading}
                            type='submit'
                            bg={'red'}
                            isSmall={true}
                            onClick={() => handleDeleteForm()}
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}